import { FunctionalComponent } from 'preact';
import { useEffect, useState/*, useRef*/ } from 'preact/hooks';
import { useDispatch, useSelector } from 'react-redux';

import { getTranslation } from '../../../shared/chromeApi';
import { timeInMs } from '../../../shared';
import { fetchTotalCounter, selectTotalCounter } from './slice';

// import SEQUENTIAL_MESSAGES from './messages/sequential.json';
// import PERMANENT_MESSAGES from './messages/permanent.json';

import styles from './styles.module.scss';
// import { selectTotalShellsCounter, selectLoggedUser } from '../user/slice';
// import { stringTemplateParser } from './utils';
import { selectUiMode } from '../../store/selectors';

const SCALE_DOWN_FACTOR = 0.9;
const BOTTLES_DIVISOR = 5;
const LINE_HEIGHT = 16;
const BASE_HEIGHT = 32;

const getBottlesCounter = (num: string | number): string =>
  num ? Math.floor(Number(num) / BOTTLES_DIVISOR).toLocaleString() : null;

const BOTTLES_PLACEHOLDER = '00000000';

const OverallCounter: FunctionalComponent = () => {
  const dispatch = useDispatch();

  const uiMode = useSelector(selectUiMode);
  // const user = useSelector(selectLoggedUser);

  const totalCounter = useSelector(selectTotalCounter);
  // const totalShellsCounter = useSelector(selectTotalShellsCounter);
  // const bottlesCounter = Math.floor(totalShellsCounter / 100);

  const [state, setState] = useState({
    // bottlesCounter,
    counter: totalCounter?.total,
  });
  // const [isGainedBottle, setIsGainedBottle] = useState(false);

  // const timerRef = useRef<ReturnType<typeof setTimeout>>(null);
  // const innerRef = useRef<HTMLDivElement>(null);
  // const [innerHeight, setInnerHeight] = useState(0);
  const [messageHovered, setMessageHovered] = useState(false);

  // const startCount = (): void => {
  //   timerRef.current =
  //     timerRef.current ||
  //     setTimeout(() => {
  //       setIsGainedBottle(false);
  //     }, 12000);
  // };

  // const stopCount = (): void => {
  //   clearTimeout(timerRef.current);
  //   timerRef.current = null;
  // };

  useEffect(() => {
    dispatch(fetchTotalCounter());
  }, []);

  useEffect(() => {
    if (!totalCounter) return;

    const extra = Math.floor(
      (totalCounter.lastWeek / 7) *
      ((Date.now() - totalCounter.fetchedAt) / timeInMs.day) *
      SCALE_DOWN_FACTOR
    );

    setState((prev) => ({
      ...prev,
      counter: (state.counter || totalCounter?.total) + extra,
    }));
  }, [!!totalCounter]);

  // useEffect(() => {
  //   if (!totalCounter) return;
  //   const bottlesGain = bottlesCounter - state.bottlesCounter;
  //   if (bottlesCounter === 1 || bottlesGain !== 1 || uiMode === 'focus') return;
  //   setTimeout(() => {
  //     setState({ ...state, bottlesCounter, counter: state.counter + BOTTLES_DIVISOR });
  //     setIsGainedBottle(true);
  //   }, 1700);
  //   const styles = getComputedStyle(innerRef.current);
  //   const heightPlusPaddings = (innerRef.current as HTMLElement).clientHeight;
  //   const padding = parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);
  //   setInnerHeight(heightPlusPaddings - padding);
  //   startCount();
  // }, [bottlesCounter, !!totalCounter]);

  const totalBottles = getBottlesCounter(state?.counter) || BOTTLES_PLACEHOLDER;
  const shouldRender =
    typeof window === 'undefined' || totalBottles === BOTTLES_PLACEHOLDER
      ? styles.prerendered
      : '';

  // const message = (() => {
  //   if (uiMode === 'focus') return null;
  //   const messages = SEQUENTIAL_MESSAGES[bottlesCounter - 1] || [
  //     PERMANENT_MESSAGES[bottlesCounter % PERMANENT_MESSAGES.length],
  //   ];
  //   return messages[1] && user?.name
  //     ? stringTemplateParser(messages[1], user?.name)
  //     : messages[0];
  // })();
  const message = uiMode === 'focus' ? null : 'Every search helps clean the oceans';

  return (
    <div className={styles.overallCounter}>
      <a
        // onClick={handleClickCounter}
        href="https://about.oceanhero.today/certificates"
      >
        <span className={`${styles.totalCounterValue} ${shouldRender}`}>
          {totalBottles.slice(0, -1)}
          <span
            className={`${styles.lastDigit} ${/*isGainedBottle ? styles.highlight :*/ ''} ${shouldRender}`}
          >
            {totalBottles.slice(-1)}
          </span>
        </span>
        <img src="img/bottle-counter.webp" alt="" style={{ opacity: 0.7 }} />
      </a>
      <div
        className={`${styles.thankYouMessage} ${/*isGainedBottle ? styles.display :*/ ''}`}
        // onMouseEnter={stopCount}
        // onMouseLeave={startCount}
      >
        <span
          className={styles.arrow}
          style={{
            background: messageHovered ? '#FFFFFF' : 'rgba(255, 255, 255, 0.3)',
          }}
        />

        {message && (
          <div
            className={styles.messagePopover}
            style={{
              bottom: BASE_HEIGHT - LINE_HEIGHT / 2,
              // bottom: BASE_HEIGHT + (innerHeight / LINE_HEIGHT - 1) * (LINE_HEIGHT / 2),
            }}
          >
            <div
              // ref={innerRef}
              className={styles.inner}
              onMouseEnter={(): void => setMessageHovered(true)}
              onMouseLeave={(): void => setMessageHovered(false)}
              style={{
                background: messageHovered
                  ? '#FFFFFF'
                  : 'rgba(255, 255, 255, 0.3)',
              }}
            >
              <p
                className={styles.message}
                style={{ color: messageHovered ? '#0c2758' : '#FFFFFF' }}
              >
                {message}
              </p>
            </div>
          </div>
        )}
      </div>
      <div className={styles.popover}>
        <div className={styles.outerPopover}>
          <div className={styles.innerPopover}>
            <p className={styles.description}>
              {getTranslation('total_counter_message')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverallCounter;
